import React from 'react';

export function Bolt() {
  return (
    <svg
      width="44"
      height="65"
      viewBox="0 0 44 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8662 1.12885C28.0159 -0.433068 30.49 0.573172 30.2232 2.49419L25.0065 40.0545H1.90981C0.37708 40.0545 -0.504269 38.3114 0.40436 37.077L26.8662 1.12885Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.4564 24.668C42.9892 24.668 43.8705 26.4111 42.9619 27.6455L16.5 63.5937C15.3503 65.1556 12.8762 64.1493 13.143 62.2283L18.3597 24.668L41.4564 24.668Z"
        fill="currentColor"
      />
    </svg>
  );
}
